import { useQuery, gql } from "@apollo/client";

export const GET_ALL_REGISTERED_DOGS_SIT = gql`
  query GetAllRegisteredDogsSIT(
    $pageNumber: Int!
    $pageSize: Int!
    $search: String!
  ) {
    getAllRegisteredDogsSIT(
      pageNumber: $pageNumber
      pageSize: $pageSize
      search: $search
    ) {
      pageNumber
      pageSize
      totalDocs
      totalPages
      totalCount
      data {
        id
        call_name
        registration_name
        breed
        authId
        owner_name
        birch
        anise
        clove
        dog_id
      }
    }
  }
`;

export const UPDATE_DOG_STATUS = gql`
  mutation updateRegisteredDogSITStatus($id: Int!, $data: UpdateDogSitInput!) {
    updateRegisteredDogSITStatus(id: $id, data: $data) {
      message
    }
  }
`;
